import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 800px;
  max-width: 1000px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  color: #2B4B81; /* Primary color */
  display: flex;
  align-items: center;
  gap: 8px;

  &:before {
    content: 'Skill Level History';
    color: #6B89B7; /* Secondary color */
    font-weight: 500;
  }

  span {
    &:before {
      content: '|';
      margin: 0 8px;
      color: #6B89B7; /* Secondary color */
      font-weight: 400;
    }
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: #666;
  &:hover {
    color: #333;
  }
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 400px;
`;